/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AirlineListExportRequest,
  AirlineWriteRequest,
  GetAirlineResponse,
  ListRequest,
  ListResponseOfAirlineListItem,
  SaveAirlineBaggageRuleRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const createInventoryAirline = (
    airlineWriteRequest: AirlineWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/inventory/airlines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: airlineWriteRequest, signal
    },
      );
    }
  


export const getCreateInventoryAirlineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryAirline>>, TError,{data: AirlineWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryAirline>>, TError,{data: AirlineWriteRequest}, TContext> => {

const mutationKey = ['createInventoryAirline'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryAirline>>, {data: AirlineWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createInventoryAirline(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryAirlineMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryAirline>>>
    export type CreateInventoryAirlineMutationBody = AirlineWriteRequest
    export type CreateInventoryAirlineMutationError = ErrorType<unknown>

    export const useCreateInventoryAirline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryAirline>>, TError,{data: AirlineWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryAirline>>,
        TError,
        {data: AirlineWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateInventoryAirlineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const inventoryAirlineList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfAirlineListItem>(
      {url: `/api/inventory/airlines/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getInventoryAirlineListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryAirlineList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryAirlineList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['inventoryAirlineList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryAirlineList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  inventoryAirlineList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InventoryAirlineListMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryAirlineList>>>
    export type InventoryAirlineListMutationBody = ListRequest
    export type InventoryAirlineListMutationError = ErrorType<unknown>

    export const useInventoryAirlineList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryAirlineList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryAirlineList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getInventoryAirlineListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const inventoryAirlineListExport = (
    airlineListExportRequest: AirlineListExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/inventory/airlines/list/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: airlineListExportRequest, signal
    },
      );
    }
  


export const getInventoryAirlineListExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryAirlineListExport>>, TError,{data: AirlineListExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryAirlineListExport>>, TError,{data: AirlineListExportRequest}, TContext> => {

const mutationKey = ['inventoryAirlineListExport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryAirlineListExport>>, {data: AirlineListExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  inventoryAirlineListExport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InventoryAirlineListExportMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryAirlineListExport>>>
    export type InventoryAirlineListExportMutationBody = AirlineListExportRequest
    export type InventoryAirlineListExportMutationError = ErrorType<unknown>

    export const useInventoryAirlineListExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryAirlineListExport>>, TError,{data: AirlineListExportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryAirlineListExport>>,
        TError,
        {data: AirlineListExportRequest},
        TContext
      > => {

      const mutationOptions = getInventoryAirlineListExportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateInventoryAirline = (
    id: number,
    airlineWriteRequest: AirlineWriteRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/airlines/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: airlineWriteRequest
    },
      );
    }
  


export const getUpdateInventoryAirlineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryAirline>>, TError,{id: number;data: AirlineWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryAirline>>, TError,{id: number;data: AirlineWriteRequest}, TContext> => {

const mutationKey = ['updateInventoryAirline'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryAirline>>, {id: number;data: AirlineWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryAirline(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryAirlineMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryAirline>>>
    export type UpdateInventoryAirlineMutationBody = AirlineWriteRequest
    export type UpdateInventoryAirlineMutationError = ErrorType<unknown>

    export const useUpdateInventoryAirline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryAirline>>, TError,{id: number;data: AirlineWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryAirline>>,
        TError,
        {id: number;data: AirlineWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateInventoryAirlineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getInventoryAirline = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAirlineResponse>(
      {url: `/api/inventory/airlines/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetInventoryAirlineQueryKey = (id?: number,) => {
    return [
    `/api/inventory/airlines/${id}`
    ] as const;
    }

    
export const getGetInventoryAirlineQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryAirline>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryAirline>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryAirlineQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryAirline>>> = ({ signal }) => getInventoryAirline(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryAirline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryAirlineQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryAirline>>>
export type GetInventoryAirlineQueryError = ErrorType<void>


export function useGetInventoryAirline<TData = Awaited<ReturnType<typeof getInventoryAirline>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryAirline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryAirline>>,
          TError,
          Awaited<ReturnType<typeof getInventoryAirline>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryAirline<TData = Awaited<ReturnType<typeof getInventoryAirline>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryAirline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryAirline>>,
          TError,
          Awaited<ReturnType<typeof getInventoryAirline>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryAirline<TData = Awaited<ReturnType<typeof getInventoryAirline>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryAirline>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInventoryAirline<TData = Awaited<ReturnType<typeof getInventoryAirline>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryAirline>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryAirlineQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveInventoryAirlineBaggageRule = (
    id: number,
    saveAirlineBaggageRuleRequest: SaveAirlineBaggageRuleRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/inventory/airlines/${id}/baggage-rules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveAirlineBaggageRuleRequest, signal
    },
      );
    }
  


export const getSaveInventoryAirlineBaggageRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryAirlineBaggageRule>>, TError,{id: number;data: SaveAirlineBaggageRuleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveInventoryAirlineBaggageRule>>, TError,{id: number;data: SaveAirlineBaggageRuleRequest}, TContext> => {

const mutationKey = ['saveInventoryAirlineBaggageRule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveInventoryAirlineBaggageRule>>, {id: number;data: SaveAirlineBaggageRuleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saveInventoryAirlineBaggageRule(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveInventoryAirlineBaggageRuleMutationResult = NonNullable<Awaited<ReturnType<typeof saveInventoryAirlineBaggageRule>>>
    export type SaveInventoryAirlineBaggageRuleMutationBody = SaveAirlineBaggageRuleRequest
    export type SaveInventoryAirlineBaggageRuleMutationError = ErrorType<unknown>

    export const useSaveInventoryAirlineBaggageRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryAirlineBaggageRule>>, TError,{id: number;data: SaveAirlineBaggageRuleRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveInventoryAirlineBaggageRule>>,
        TError,
        {id: number;data: SaveAirlineBaggageRuleRequest},
        TContext
      > => {

      const mutationOptions = getSaveInventoryAirlineBaggageRuleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteInventoryAirlineBaggageRule = (
    id: number,
    ruleId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/airlines/${id}/baggage-rules/${ruleId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInventoryAirlineBaggageRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryAirlineBaggageRule>>, TError,{id: number;ruleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryAirlineBaggageRule>>, TError,{id: number;ruleId: string}, TContext> => {

const mutationKey = ['deleteInventoryAirlineBaggageRule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventoryAirlineBaggageRule>>, {id: number;ruleId: string}> = (props) => {
          const {id,ruleId} = props ?? {};

          return  deleteInventoryAirlineBaggageRule(id,ruleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventoryAirlineBaggageRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventoryAirlineBaggageRule>>>
    
    export type DeleteInventoryAirlineBaggageRuleMutationError = ErrorType<unknown>

    export const useDeleteInventoryAirlineBaggageRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryAirlineBaggageRule>>, TError,{id: number;ruleId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventoryAirlineBaggageRule>>,
        TError,
        {id: number;ruleId: string},
        TContext
      > => {

      const mutationOptions = getDeleteInventoryAirlineBaggageRuleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    